// requestTracker.js
let pendingRequests = 0;
const listeners = new Set();

export const subscribeToRequests = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

const notify = () => {
  for (const callback of listeners) {
    callback(pendingRequests);
  }
};

export const incrementRequests = () => {
  pendingRequests++;
  notify();
};

export const decrementRequests = () => {
  pendingRequests--;
  notify();
};

export const isRequestPending = () => pendingRequests > 0;
